export const KOREAN_FOOTER_CONSTANTS = {
  KOREAN_ESCROW_PAYMENT_URL: 'https://tnec.fpg.kr/escrow.html',
  KOREAN_BUSINESS_INFO_PHONE: '220-88-09068',
  KOREAN_BUSINESS_INFO_URL: 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208809068',
  KOREAN_CUSTOMER_SERVICE_EMAIL: 'service@nike.co.kr',
  KOREAN_CUSTOMER_SERVICE_FAX: '02-6744-5880',
  KOREAN_CUSTOMER_SERVICE_PHONE: '080-022-0182',
  KOREAN_SECURE_PAYMENT_ICON: '//image.inicis.com/mkt/certmark/escrow/escrow_43x43_gray.png',
};
